// Timeout acotado al blast radius del Planner (D2). NO se fija en axios.create
// (services/api.js): ese cliente lo comparten 11 consumidores fuera de scope
// (login, billing, password) que no se validan aquí. El timeout se inyecta por
// request solo en la familia Planner (Planner.fetchData, WeekView, MonthView,
// poller de Waitlist).
export const PLANNER_REQUEST_TIMEOUT_MS = 20000;

// Config por request para las calls de la familia Planner. Mezcla el timeout
// con lo que pase el caller (p.ej. `signal` de AbortController). El caller puede
// sobrescribir `timeout` explícitamente pasándolo en `extra`.
//
// `suppressGlobalToast: true` se aplica automáticamente a las calls que pasan
// por este helper. El response interceptor en services/api.js lo lee para NO
// emitir un toast global — cada call site del Planner ya emite su propio
// `toast.error(...)`, así que emitir el global produce el doble toast (D4).
export function plannerRequestConfig(extra = {}) {
  return { timeout: PLANNER_REQUEST_TIMEOUT_MS, suppressGlobalToast: true, ...extra };
}

// Cadencia del refresco automático del Day Planner (R1): cada cuánto se
// vuelve a pedir /availability, /bookings y /breaks de la fecha visible en
// segundo plano, sin tocar `loading` ni bloquear la UI. Independiente del
// timeout de arriba: este es el intervalo entre ticks, no el límite por
// request.
export const PLANNER_AUTO_REFRESH_INTERVAL_MS = 30000;